<template>
    <or-layout>
        <a-row :gutter="[16, 16]" type="flex" justify="space-between">
            <a-col>
                <a-form layout="inline">
                    <a-form-item>
                        <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                            :placeholder="['开始时间', '结束时间']" @change="onChange" />
                    </a-form-item>
                    <a-button type="primary" @click="getTableList(0)">搜索</a-button>
                </a-form>
            </a-col>
        </a-row>
        <a-divider></a-divider>
        <div>
            <a-button @click="exportData">导出</a-button>
            <a-table :columns="columns" :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo"
                :loading="loading" bordered>
                <!-- <a-table-column key="teacher_name" title="老师名字" data-index="teacher_name" />
                <a-table-column key="success_number" title="规定时间内批改数" data-index="success_number" />
                <a-table-column key="error_number" title="超时批改数" data-index="error_number" />
                <a-table-column key="number" title="批改总数" data-index="number" /> -->
            </a-table>
        </div>
    </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
const columns = [
    {
        title: '老师名字',
        dataIndex: 'teacher_name',
    },
    {
        title: '规定时间内批改数',
        dataIndex: 'success_number',
        sorter: (a, b) => a.success_number - b.success_number,
    },
    {
        title: '超时批改数',
        dataIndex: 'error_number',
        sorter: (a, b) => a.error_number - b.error_number,
    },
    {
        title: '批改总数',
        dataIndex: 'number',
        sorter: (a, b) => a.number - b.number,
    }
]

export default {
    components: {
        AFormItem
    },
    data() {
        let nowDate = new Date()
        return {
            columns,
            data: [],
            loading: false,
            searchFrom: {
                org_id: "326a6ccf295111320d93993af89a97b3",
                start_time: '',
                end_time: '',
                export: 0

            },
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 99
            },
        };
    },
    methods: {
        onChange(value, dateString) {
            dateString,
                this.searchFrom.start_time = parseInt(Number(value[0] / 1000));
            this.searchFrom.end_time = parseInt(Number(value[1] / 1000));
        },
        getTableList(value) {
            this.searchFrom.export = value;
            if (this.searchFrom.end_time && this.searchFrom.start_time) {
                this.loading = true;
                this.$axios
                    .post("/api/TeacherPerformance/getTeacherPerformance", {
                        data: this.searchFrom
                    })
                    .then(res => {
                        this.loading = false;
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定"
                            });
                        } else {
                            if (value == 0) {
                                this.data = res.data;
                                this.pageinfo.pageSize = res.data.length;
                            } else {
                                window.open(res.data)
                            }
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            } else {
                this.$error({
                    title: "错误",
                    content: '请填入时间段',
                    okText: "确定"
                })
            }

        },

        exportData() {
            this.getTableList(1)
        },

    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
